import { emailSafe } from '@saulx/validators'

export const isEmailValid = (email: string) => {
  // TODO: exclude '+' in emails

  return emailSafe(email)
}

/**
 * Normalize an email address for duplicate detection.
 *
 * Rules (ReDoS-immune — zero regex, only O(n) string primitives):
 * - Trim and lowercase the entire address.
 * - Strip everything after `+` in the local part (all providers).
 * - For Gmail / Googlemail: strip `.` from local part; map googlemail.com → gmail.com.
 * - Invalid input (no `@`, empty local/domain) is returned as-is; let validation reject it.
 */
export const normalizeEmail = (email: string): string => {
  const normalised = email.trim().toLowerCase()

  const atIndex = normalised.lastIndexOf('@')
  if (atIndex < 1 || atIndex === normalised.length - 1) {
    return normalised
  }

  let local = normalised.slice(0, atIndex)
  let domain = normalised.slice(atIndex + 1)

  const plusIndex = local.indexOf('+')
  if (plusIndex !== -1) {
    local = local.slice(0, plusIndex)
  }

  if (domain === 'gmail.com' || domain === 'googlemail.com') {
    // split+join instead of regex replace — zero ReDoS surface
    local = local.split('.').join('')
    domain = 'gmail.com'
  }

  return local + '@' + domain
}
